export * from './burial-society-documents.Configuration';
